



























































import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { LoginOut } from "@/request/common";
@Component({})
export default class Login extends Vue {
  private size: any = "大";
  private get user() {
    return this.$store.state.user;
  }
  private get href() {
    return window.location.href;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get system() {
    return this.$store.state.system;
  }
  private changeSize() {
    if (this.size == "大") {
      document.documentElement.style.setProperty("--bigSize", "30px");
      document.documentElement.style.setProperty("--h1Size", "22px");
      document.documentElement.style.setProperty("--h2Size", "20px");
      document.documentElement.style.setProperty("--h3Size", "18px");
      document.documentElement.style.setProperty("--mainSize", "16px");
      document.documentElement.style.setProperty("--miniSize", "14px");
    } else if (this.size == "小") {
      document.documentElement.style.setProperty("--bigSize", "28px");
      document.documentElement.style.setProperty("--h1Size", "20px");
      document.documentElement.style.setProperty("--h2Size", "18px");
      document.documentElement.style.setProperty("--h3Size", "16px");
      document.documentElement.style.setProperty("--mainSize", "14px");
      document.documentElement.style.setProperty("--miniSize", "12px");
    }
  }
  /**
   * @description 切换系统
   */
  private handleXitong(command: any) {
    this.$store.commit("updateToken", "");
    this.$store.commit("updateUser", "");
    if (command === "跳转用户端") {
      this.$store.commit("updateSystem", "用户端");
      this.$router.replace("/home");
    } else if (command === "跳转管理端") {
      this.$store.commit("updateSystem", "管理端");
      this.$router.replace("/access/login");
    }
  }
  private goRouter(item: any) {
    if (!item.path) {
      return;
    }
    if (item.value == "EDC工作台") {
      window.open(item.path);
      return;
    }
    if (item.value == "知识库" || item.value == "循证服务") {
      // 拦截未登录
      const token = this.$store.state.token;
      const user = this.$store.state.user;
      if (!token || !user || (!user.userId && !user.id)) {
        this.$confirm("查看更多内容请先登录", "登录", {
          customClass: "commonConfirm",
        }).then(() => {
          // 跳转登录
          this.$router.push("/access/login?path=" + item.path);
        });
        return;
      }
    }
    clearFilter();
    this.$router.push(item.path);
  }
  /**
   * @description 点击切换账号
   */
  private handleCommand(command: any) {
    if (command === "退出登录") {
      this.$message.success("退出成功");
      this.$store.commit("updateToken", "");
      this.$store.commit("updateUser", "");
      location.reload();
      return;
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      LoginOut(this, loading)
        .then(() => {
          loading.close();
          this.$message.success("退出成功");
          this.$store.commit("updateToken", "");
          this.$store.commit("updateUser", "");
          // 刷新页面
          location.reload();
          // this.$router.push("/access/login");
        })
        .catch(() => {
          loading.close();
        });
    }
  }
  private goLogin() {
    this.$store.commit("updateSystem", "用户端");
    this.$router.push("/access/login");
  }
  private goGuanliLogin() {
    this.$store.commit("updateSystem", "管理端");
    this.$router.push("/access/login");
  }
  private goRegister() {
    this.$router.push("/access/register");
  }
  private mounted() {
    this.changeSize();
  }
}
